import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { IconBuilding, IconSettings, IconUser } from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";

import AdminNavBar, { IMenuItem } from "../../components/AdminNavBar/AdminNavBar";
import { useStyles } from "./OperationAndRiskLayout.styles";

interface IProps {
  content: ReactNode;
}

const menus: IMenuItem[] = [
  {
    label: "Organisations",
    path: "/org-list",
    icon: IconBuilding,
  },
  {
    label: "Individuals",
    path: "/individual-list",
    icon: IconUser,
  },
  {
    label: "Merchant Configurator",
    path: "/merchant-configurator",
    icon: IconSettings,
  },
];

const OperationAndRiskLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <AdminNavBar menus={menus} />
      <div className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default OperationAndRiskLayout;
